import * as Sentry from "@sentry/vue";

export let sentryClient: ReturnType<typeof Sentry.init> | null = null;

/** Span covering one streamed load of the mimbox table, see `useMimboxTableData` */
export const MIMBOX_TABLE_LOAD_SPAN = "mimbox-table.load";

/**
 * Traces we always keep: the mimbox table page (a pageload is named by its path until the router
 * resolves it, a navigation by its route name) and the table load itself, so staff load times
 * aren't thinned out by sampling.
 */
const ALWAYS_TRACED = new Set(["/mimbox", "mimboxes", MIMBOX_TABLE_LOAD_SPAN]);
const DEFAULT_TRACES_SAMPLE_RATE = 0.1;

export const initSentry = (app: any, router: any) => {
  if (import.meta.env.PROD) {
    sentryClient = Sentry.init({
      app,
      dsn: "https://5536c4f1c2e6ecc0f41212884909f366@o4510991720906752.ingest.de.sentry.io/4510991722741840",
      sendDefaultPii: true,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      tracesSampler: ({ name, inheritOrSampleWith }) =>
        ALWAYS_TRACED.has(name) ? 1 : inheritOrSampleWith(DEFAULT_TRACES_SAMPLE_RATE),
      // Links browser traces to the Cloud Functions they call
      tracePropagationTargets: [
        /^https:\/\/europe-west1-mimblysoftware\.cloudfunctions\.net\//,
        /^https:\/\/[a-z0-9-]+\.a\.run\.app\//,
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      enableLogs: true,
    });
  }
  return sentryClient;
};
